import AgreementsPage from '@totem/components/agreements/AgreementReport/AgreementsPage';
import ControlSystemDetail from '@totem/components/controlSystemDetail/ControlSystemDetail';
import ControlSystemReportPage from '@totem/components/controlSystemReport/ControlSystemReportPage';
import OrgManagementPage from '@totem/components/orgManagement/OrgManagementPage';
import BuildingDetail from '@totem/components/portfolio/buildings/details/BuildingDetail';
import BuildingSummaryPage from '@totem/components/portfolio/buildings/list/buildingSummary/BuildingSummaryPage';
import RegionDetailsPage from '@totem/components/portfolio/regions/details/RegionDetailsPage';
import RegionsPage from '@totem/components/portfolio/regions/list/RegionsPage';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import { Route } from '@totem/types/route';
import { UserProfile } from '@totem/types/user';

export const organizationRoutes: Route[] = [
  {
    path: 'organizationManagement',
    pageTitle: 'Organization Management',
    component: OrgManagementPage,
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministratorIBOrg.hasPermissions(userProfile),
  },
  {
    path: 'regions',
    pageTitle: 'Regions',
    component: RegionsPage,
    exact: true,
    breadcrumbs: [{ label: 'Regions', link: '/regions' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'regions/details/:id',
    pageTitle: 'Region Details',
    component: RegionDetailsPage,
    exact: true,
    breadcrumbs: [
      { label: 'Regions', link: '/regions' },
      { label: 'Region Details' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'buildings',
    pageTitle: 'Buildings',
    component: BuildingSummaryPage,
    exact: true,
    breadcrumbs: [{ label: 'Buildings', link: '/buildings' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'buildings/:id',
    pageTitle: 'Building Detail',
    component: BuildingDetail,
    exact: true,
    breadcrumbs: [
      { label: 'Buildings', link: '/buildings' },
      { label: 'Building Overview' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'controlSystemReport',
    pageTitle: 'Control Systems',
    component: ControlSystemReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Control System Report' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'controlsystems/:id',
    pageTitle: 'System Detail',
    component: ControlSystemDetail,
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'agreements',
    pageTitle: 'Agreements',
    component: AgreementsPage,
    exact: true,
    breadcrumbs: [{ label: 'Agreements' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
];
